import { render, staticRenderFns } from "./BacsDebitSvg.vue?vue&type=template&id=73c957b5&scoped=true&"
import script from "./BacsDebitSvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BacsDebitSvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c957b5",
  null
  
)

export default component.exports